import { useCallback, useState } from 'react';
import { ISort } from '@entities/util/ISort';
import { sortHandler } from '@app/utils/sort';
function useSort(): [ISort | null, (column: string) => void] {
  const [sort, updateSort] = useState<ISort | null>(null);

  const setSort = useCallback(
    (column: string) => {
      const sortConfig = sortHandler(sort, column);
      updateSort(sortConfig);
    },
    [sort?.column, sort?.type]
  );

  return [sort, setSort];
}

export default useSort;
